import type { ClimateEvidence } from '../types/siteEvidence';
import type { SiteRagReport, TimeSeriesData } from '../types/siteRag';

/** Map SED climate monthlySummary → report chart TimeSeriesData. */
export function monthlySummaryToTimeSeries(
  monthly: ClimateEvidence['monthlySummary'] | undefined,
): TimeSeriesData[] {
  if (!monthly?.length) return [];
  return monthly.map(m => ({
    month: m.month,
    avgTemp: m.avgTemp,
    peakTemp: m.maxTemp,
    minTemp: m.minTemp,
    wetBulbTemp: m.wetBulb,
    precipitation: m.precipitation,
    coolingEfficiency: m.coolingEfficiency,
  }));
}

/**
 * Resolve monthly climate points for Climate Profile Chart.
 * Prefers persisted report.timeSeries; falls back to live SED climate.
 */
export function resolveReportTimeSeries(
  report: SiteRagReport,
  sedClimate?: ClimateEvidence | null,
): TimeSeriesData[] {
  if (report.timeSeries?.length) return report.timeSeries;
  const fromSed = monthlySummaryToTimeSeries(sedClimate?.monthlySummary);
  if (fromSed.length) return fromSed;
  const climate = report.datasets?.climate as { timeSeries?: TimeSeriesData[] } | undefined;
  if (climate?.timeSeries?.length) return climate.timeSeries;
  return [];
}
